import React, { createContext, useContext, useState } from "react";

const RobotContext = createContext();

export const useRobot = () => {
  const context = useContext(RobotContext);
  if (!context) {
    throw new Error("useRobot must be used within a RobotProvider");
  }
  return context;
};

export const RobotProvider = ({ children }) => {
  const [robot, setRobot] = useState(null);

  return (
    <RobotContext.Provider value={{ robot, setRobot }}>
      {children}
    </RobotContext.Provider>
  );
};
